const absNumberSort = (rowA, rowB, columnId) => {
    const a = Math.abs(parseFloat(rowA.values[columnId]) || 0)
    const b = Math.abs(parseFloat(rowB.values[columnId]) || 0)
    return a - b
}

export default absNumberSort